import { stripSrpPageSegment } from '@/src/lib/seo/srp-pagination';

export const SORT_ORDER_KEY = 'orderBy';

export function buildSortCriteriaUrl(
  pathname: string | null | undefined,
  searchParams: URLSearchParams,
  sortValue: string,
): string {
  const params = new URLSearchParams(searchParams.toString());
  params.delete('page');

  if (sortValue === 'recommended') {
    params.delete(SORT_ORDER_KEY);
  } else {
    params.set(SORT_ORDER_KEY, sortValue);
  }

  const basePathname = stripSrpPageSegment(pathname ?? '/');
  const queryString = params.toString();
  return queryString ? `${basePathname}?${queryString}` : basePathname;
}
